// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Xa9S","addWidgetButton":"Header_addWidgetButton__rDUfn","dashboardTabs":"Header_dashboardTabs__3Ha4m","active":"Header_active__2DlXc"};